<script setup lang="ts">
// One notification: its module's renderer if it registered one, else the title,
// the body and when it arrived.
import { notificationRenderer } from '@itc/sdk';
import type { NotificationItem } from '@itc/shared';
import { computed } from 'vue';
import { modules } from '../modules.ts';

const props = defineProps<{ item: NotificationItem }>();
const renderer = computed(() => notificationRenderer(modules, props.item.kind));
const when = computed(() => new Date(props.item.createdAt).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }));
</script>

<template>
  <component :is="renderer" v-if="renderer" :item="item" />
  <div v-else class="notification">
    <div class="itc-data-row__title notification__title">{{ item.title }}</div>
    <div v-if="item.body" class="notification__body">{{ item.body }}</div>
    <div class="itc-data-row__meta">{{ when }}</div>
  </div>
</template>

<style scoped>
.notification__body {
  margin-top: 2px;
  color: var(--itc-muted);
  font-size: 13px;
  white-space: pre-line;
}
</style>
